<template>
    <v-text-field
        :label="$t('instance.data_model.form_editor.fields_types.text_field.default_field')"
        v-model="valueCopy"
        :rules="rules"
        :disabled="readOnly"
        @change="emitValue"
    ></v-text-field>
</template>

<script>
import FieldMixin from './field-mixin.vue';
export default {
    mixins: [FieldMixin],
    components: {

    },

    props: {
    },

    data (){
        return {
        };
    },

    computed: {
        rulesList (){
            return {
                char: this.formActive ?[
                    v => !v,
                ]: [],
                bool: this.formActive ?[
                    v => v === ''  || v === undefined || typeof v === 'boolean' || ['', 'true', 'false'].includes(v.toLowerCase()) || this.$t('instance.data_model.form_editor.fields_types.text_field.rules.bool'),
                ]: [],
                uid: this.formActive ?[
                    v => v === '' || this.uuidV4Regex.test(v) || this.$t('instance.data_model.form_editor.fields_types.text_field.rules.uid')
                ]: [],
                email: this.formActive ?[
                    v => v === '' || this.emailRegex.test(v) || this.$t('instance.data_model.form_editor.fields_types.text_field.rules.email')
                ]: [],
            };
        },
        uuidV4Regex (){
            return /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i;
        },
        emailRegex (){
            return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        },
    },
    mounted (){
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Instance/DataModel/FormEditor/FieldsTypes/txt-field.vue